import React, { useContext } from 'react';
import { CardContent, CardActions, Box, Typography } from '@mui/material';
import { Button, Card } from '@pennfoster/pfc-design-system';
import { Link } from 'react-router-dom';
import { trackNamedEvent } from 'src/events/track-events';
import { DASHBOARD } from 'src/routes/routemap';
import UserContext from 'src/context/user';
import ConfirmationPaymentIcon from 'src/assets/svg/confirmationPayment.svg';

interface ConfirmationPaymentCardProps {
  confirmationMessage?: string;
}

export default function ConfirmationPaymentCard({
  confirmationMessage,
}: ConfirmationPaymentCardProps) {
  const { user } = useContext(UserContext);

  return (
    <>
      <Card
        pfVariant="default"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'space-between',
          maxWidth: '460px',
        }}
      >
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            margin: 0,
            padding: 0,
          }}
        >
          <Box
            sx={{
              backgroundColor: 'rgba(38, 187, 154, 1);',
              height: '60px',
              margin: 0,
              position: 'relative',
            }}
          >
            <Box
              sx={{
                height: '43.33px',
                textAlign: 'center',
                position: 'absolute',
                top: '30%',
                left: '50%',
                transform: 'translate(-50%, 30%)',
              }}
            >
              <img src={ConfirmationPaymentIcon} alt="Confirmation Icon" />
            </Box>
          </Box>
          <Typography
            sx={{
              color: 'rgba(26, 127, 105, 1)',
              fontFamily: 'Merriweather',
              fontSize: '24px',
              fontWeight: 400,
              lineHeight: '32px',
              letterSpacing: '0em',
              margin: '40px 64px',
              textAlign: 'center',
            }}
          >
            Your payment has been confirmed!
          </Typography>

          <Box sx={{ margin: '0px 64px' }}>
            <Typography
              sx={{
                fontFamily: 'Nunito Sans',
                fontSize: '16px',
                fontWeight: 400,
                lineHeight: '24px',
                letterSpacing: '0em',
                textAlign: 'center',
              }}
            >
              {confirmationMessage}
            </Typography>
          </Box>
        </CardContent>
        <CardActions sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            sx={{
              m: 1,
              textAlign: 'center',
            }}
            size="small"
            color="primary"
            pfVariant="filled"
            component={Link}
            to={DASHBOARD}
            onClick={() =>
              trackNamedEvent({
                eventName: 'MakeAPaymentClick',
                user,
                dataSource: {},
              })
            }
          >
            Go to Home
          </Button>
        </CardActions>
      </Card>
    </>
  );
}
